
import React from 'react';
import { Star } from 'lucide-react';
import { PsychologistCardData } from './types';

interface PsychologistCardRatingProps {
  psychologist: PsychologistCardData;
}

const PsychologistCardRating: React.FC<PsychologistCardRatingProps> = ({ psychologist }) => {
  const rating = psychologist.average_rating || psychologist.rating || 0;

  return (
    <div className="flex items-center gap-1 mb-3">
      <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
      <span className="font-medium text-gray-900">{rating.toFixed(1)}</span>
      {psychologist.total_reviews && psychologist.total_reviews > 0 && (
        <span className="text-gray-500 text-sm">({psychologist.total_reviews})</span>
      )}
    </div>
  );
};

export default PsychologistCardRating;
